const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrderConfirmed2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 500",
    style: {
      enableBackground: "new 0 0 750 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 750,
    height: 500
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECT"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7FAF9"
    },
    d: "M668.928,407.638H67.23c-8.474-10.59,0.815-29.748,11.776-37.735 c10.962-7.987,24.785-12.195,33.831-22.3c14.174-15.833,11.84-39.829,10.517-61.039c-1.323-21.21,1.599-46.668,20.38-56.611 c17.322-9.171,39.149,0.045,57.941-5.524c18.566-5.502,29.768-23.691,41.139-39.365c37.983-52.356,96.287-89.557,159.772-101.945 c27.336-5.334,56.508-6.041,82.2,4.711s47.043,34.817,48.534,62.628c1.055,19.671-7.463,38.42-11.773,57.643 c-4.311,19.222-2.994,42.471,12.664,54.425c12.677,9.678,30.145,8.604,45.965,10.629c15.82,2.024,33.983,11.195,34.44,27.137 c0.496,17.296-20.709,31.207-16.365,47.955c2.655,10.237,13.92,15.688,24.335,17.527c10.415,1.84,21.482,1.529,30.953,6.236 C663.011,376.72,674.948,398.943,668.928,407.638z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBEED1"
    },
    d: "M259.877,131.842H102.305c-1.554-3.964,1.81-8.352,5.731-10.01 c3.921-1.658,8.365-1.232,12.608-0.872c4.242,0.36,8.75,0.572,12.505-1.435c7.26-3.879,8.241-13.61,11.543-21.151 c4.943-11.288,17.205-18.937,29.517-18.411c12.312,0.525,23.878,9.19,27.842,20.858c2.045,6.018,2.46,13.074,7.093,17.425 c4.872,4.575,12.556,4.28,19.001,2.511c6.445-1.769,12.746-4.735,19.427-4.553C254.253,116.385,260.331,125.175,259.877,131.842 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBEED1"
    },
    d: "M485.481,59.678H341.426c3.231-7.472,9.663-14.091,17.359-16.744 c7.696-2.653,16.494-1.918,23.643,1.976c4.391,2.392,8.351,5.97,13.297,6.709c7.788,1.165,14.486-4.944,21.074-9.257 c11.188-7.324,25.247-10.129,38.389-7.66C468.331,37.171,477.715,48.791,485.481,59.678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBEED1"
    },
    d: "M677.975,130.676H543.471c0.46-4.337,3.28-9.418,6.814-11.976 c3.534-2.557,8.17-3.532,12.434-2.614c3.326,0.716,6.394,2.513,9.781,2.843c5.321,0.519,10.318-2.679,14.126-6.432 c3.808-3.753,6.964-8.216,11.299-11.346c5.665-4.091,13.165-5.531,19.942-3.829c6.777,1.702,12.707,6.514,15.768,12.796 c1.315,2.699,2.117,5.627,3.485,8.3c1.368,2.672,3.47,5.178,6.347,6.037c4.796,1.432,9.515-2.05,14.332-3.408 C665.156,118.97,674.231,124.01,677.975,130.676z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#6CA8BC"
    },
    cx: 366.257,
    cy: 458.676,
    rx: 223.122,
    ry: 7.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBA58E"
    },
    d: "M261.711,220.047h-14.157c-2.635,0-4.772,2.137-4.772,4.772v8.845 c0,2.636,2.137,4.772,4.772,4.772h11.46v-3.519l0,0c3.454,0,6.766-1.372,9.209-3.814l1.721-1.721L261.711,220.047z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBA58E"
    },
    points: "261.711,220.047 269.943,229.383 305.296,221.164 300.405,208.085  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DD8C76"
    },
    points: "300.405,208.085 298.679,208.619 298.121,222.832 305.296,221.164  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5297F4"
    },
    d: "M368.095,157.502L368.095,157.502c-4.662-3.658-11.377-3.005-15.246,1.484l-36.672,42.536 l-6.628,2.234l6.158,16.469l3.477-0.753c5.503-1.192,10.521-4.01,14.402-8.089l35.697-37.51 C373.793,169.134,373.242,161.54,368.095,157.502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3985D8"
    },
    d: "M315.902,220.749l-0.196-0.524l-6.158-16.469l-0.609-1.629 c-0.349-0.933-1.389-1.407-2.322-1.058l-6.061,2.266c-0.933,0.349-1.407,1.388-1.058,2.322l0.494,1.32l5.76,15.404 l0.71,1.898c0.349,0.933,1.388,1.407,2.322,1.058l6.061-2.266C315.777,222.722,316.251,221.683,315.902,220.749z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5DABFF"
    },
    d: "M355.167,160.757c3.41-3.956,9.105-5.021,13.714-2.567c-0.251-0.238-0.509-0.47-0.786-0.688 h0c-4.662-3.658-11.377-3.005-15.246,1.484l-36.672,42.536l-6.628,2.234l0.988,2.643l7.444-2.51L355.167,160.757z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M355.331,246.014l-76.434,20.342c-13.213,3.517-19.375,18.713-12.342,30.439l44.555,74.288 l24.808-11.008l-35.651-67.792l72.599-15.174c14.045-2.935,22.317-17.54,17.612-31.095l0,0H355.331z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBA58E"
    },
    d: "M332.706,365.144l-1.862-2.818l-14.097,6.255l3.318,6.04l15.713-4.409 C334.815,368.489,333.797,366.795,332.706,365.144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M328.83,377.311l-1.313,3.342l1.752-1.233c0.694-0.489,1.523-0.751,2.372-0.751h8.232 c-1.2-2.895-2.564-5.72-4.095-8.458l-15.713,4.409l0.949,1.727h7.159C328.671,376.348,329.012,376.849,328.83,377.311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M310.766,391.705h33.302l-0.607-2.353c-0.94-3.648-2.15-7.214-3.588-10.683h-8.232 c-0.849,0-1.678,0.262-2.372,0.751l-1.752,1.233l1.313-3.342c0.182-0.463-0.159-0.963-0.657-0.963h-7.159l-5.29,4.972 c-2.397,2.252-5.562,3.506-8.851,3.506h-3.605c-3.531,0-6.611,1.968-8.197,4.877l6.867,1.222 C304.852,391.444,307.806,391.705,310.766,391.705z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M310.766,391.705c-2.96,0-5.913-0.261-8.827-0.779l-6.867-1.222 c-0.673,1.235-1.083,2.636-1.135,4.134l10.492,0.95c1.659,0.15,3.324,0.225,4.99,0.225h35.503l-0.853-3.308H310.766z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#422C4F"
    },
    points: "330.844,362.326 316.748,368.581 318.271,371.353 333.62,366.564  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A34262"
    },
    d: "M237.405,239.173h-3.608l-9.287,32.852c-7.27,25.718-4.322,53.222,8.172,76.792l4.526,1.706 L237.405,239.173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DF4268"
    },
    d: "M224.51,272.024l9.287-32.852h-3.383l-19.061,70.752 c-1.716,6.371-7.494,10.798-14.092,10.798c-0.498,0-0.902,0.404-0.902,0.902v13.505l36.323,13.688 C220.189,325.247,217.24,297.743,224.51,272.024z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#422C4F"
    },
    cx: 193.878,
    cy: 406.181,
    r: 50.744
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#495375"
    },
    cx: 193.878,
    cy: 406.181,
    r: 36.536
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#C7D2D7"
    },
    cx: 193.878,
    cy: 406.181,
    r: 29.833
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99A3B0"
    },
    d: "M193.878,376.348c-5.633,0-10.901,1.563-15.396,4.277c2.074-0.525,4.246-0.806,6.483-0.806 c14.559,0,26.361,11.802,26.361,26.362c0,14.559-11.802,26.362-26.361,26.362c-2.237,0-4.409-0.281-6.483-0.806 c4.495,2.714,9.763,4.277,15.396,4.277c16.476,0,29.833-13.357,29.833-29.833 C223.711,389.705,210.355,376.348,193.878,376.348z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#99A3B0"
    },
    cx: 193.878,
    cy: 406.181,
    r: 13.156
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -230.4275 256.0603)",
    style: {
      fill: "#A34262"
    },
    cx: 193.878,
    cy: 406.181,
    rx: 8.913,
    ry: 8.913
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#422C4F"
    },
    cx: 454.528,
    cy: 406.181,
    r: 50.744
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#495375"
    },
    cx: 454.528,
    cy: 406.181,
    r: 36.536
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#C7D2D7"
    },
    cx: 454.528,
    cy: 406.181,
    r: 29.833
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99A3B0"
    },
    d: "M454.528,376.348c-5.633,0-10.901,1.563-15.396,4.277c2.074-0.525,4.246-0.806,6.483-0.806 c14.559,0,26.362,11.802,26.362,26.362c0,14.559-11.803,26.362-26.362,26.362c-2.237,0-4.409-0.281-6.483-0.806 c4.495,2.714,9.763,4.277,15.396,4.277c16.476,0,29.833-13.357,29.833-29.833 C484.361,389.705,471.005,376.348,454.528,376.348z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#99A3B0"
    },
    cx: 454.528,
    cy: 406.181,
    r: 13.156
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -154.0849 440.3677)",
    style: {
      fill: "#A34262"
    },
    cx: 454.528,
    cy: 406.181,
    rx: 8.913,
    ry: 8.913
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M196.325,338.974c26.136,0.823,48.489,19.115,55.444,44.323l1.13,4.095l1.227,0.603 l-2.357-8.543c-6.955-25.208-29.307-43.5-55.444-44.323c-0.675-0.021-1.351-0.032-2.03-0.032 c-11.251,0-22.045,2.934-31.532,8.414l1.727,2.885c9.062-4.861,19.231-7.453,29.805-7.453 C194.973,338.942,195.65,338.953,196.325,338.974z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2C8C2"
    },
    d: "M201.097,361.935l51.801,25.457l-1.13-4.095c-6.955-25.207-29.307-43.5-55.444-44.323 c-0.675-0.021-1.351-0.032-2.03-0.032c-10.574,0-20.743,2.593-29.805,7.453l9.305,15.539H201.097z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DF4268"
    },
    d: "M256.577,391.84h-24.212c-10.885,0-21.323-4.324-29.02-12.021l0,0 c-7.697-7.697-18.135-12.021-29.02-12.021h-28.708l9.084-9.084c10.501-10.501,24.743-16.4,39.594-16.4h0 c19.128,0,36.932,9.764,47.215,25.893L256.577,391.84z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DF4268"
    },
    d: "M237.405,239.173l-9.287,32.852c-7.446,26.341-4.179,54.556,9.09,78.498l4.636,8.366 c13.126,23.684,38.072,38.38,65.15,38.38h228.558l-8.186-29.717c-8.076-29.318-26.932-54.501-52.791-70.504l-14.801-9.16 h-127.15v5.554c0,3.689,2.354,6.966,5.85,8.144l0,0c13.604,4.584,23.37,16.568,25.114,30.817l0,0 c2.721,22.233-14.627,41.834-37.025,41.834h-18.591c-17.822,0-34.407-9.115-43.96-24.16l-8.62-13.575 c-9.505-14.969-12.757-33.07-9.056-50.412l10.013-46.917H237.405z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M459.776,287.887H322.354v-16.313h109.584c7.62,0,14.919,3.075,20.241,8.529L459.776,287.887z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2C8C2"
    },
    d: "M379.88,399.523H318.18c-27.886,0-53.606-15.152-67.123-39.542l-4.637-8.366 c-13.648-24.627-16.947-53.11-9.288-80.205c2.464-8.717,1.32-18.238-3.14-26.123c-0.613-1.085-0.231-2.46,0.853-3.074 c1.086-0.614,2.46-0.231,3.074,0.853c5.048,8.925,6.343,19.704,3.554,29.571c-7.333,25.942-4.175,53.213,8.892,76.791 l4.636,8.366c12.723,22.957,36.931,37.218,63.178,37.218h61.699c1.246,0,2.255,1.01,2.255,2.255 S381.126,399.523,379.88,399.523z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A34262"
    },
    d: "M382.115,388.435h141.37l-2.164,2.164c-3.458,3.458-8.147,5.4-13.037,5.4H397.005 C391.119,396,385.587,393.189,382.115,388.435L382.115,388.435z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#99A3B0"
    },
    cx: 443.855,
    cy: 381.09,
    r: 30.579
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#495375"
    },
    d: "M443.855,404.608c-12.968,0-23.518-10.55-23.518-23.518s10.55-23.518,23.518-23.518 c12.968,0,23.518,10.55,23.518,23.518S456.823,404.608,443.855,404.608z M443.855,360.075 c-11.588,0-21.016,9.428-21.016,21.016s9.427,21.016,21.016,21.016s21.016-9.428,21.016-21.016 S455.443,360.075,443.855,360.075z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#495375"
    },
    d: "M459.128,382.341h-30.545c-0.691,0-1.251-0.56-1.251-1.251s0.56-1.251,1.251-1.251h30.545 c0.691,0,1.251,0.56,1.251,1.251S459.818,382.341,459.128,382.341z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#495375"
    },
    d: "M456.498,377.337h-25.285c-0.691,0-1.251-0.56-1.251-1.251c0-0.691,0.56-1.251,1.251-1.251 h25.285c0.691,0,1.251,0.56,1.251,1.251C457.749,376.777,457.188,377.337,456.498,377.337z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#495375"
    },
    d: "M452.966,372.333h-18.223c-0.691,0-1.251-0.56-1.251-1.251c0-0.691,0.56-1.251,1.251-1.251 h18.223c0.691,0,1.251,0.56,1.251,1.251C454.217,371.773,453.657,372.333,452.966,372.333z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#495375"
    },
    d: "M448.765,367.33h-9.819c-0.691,0-1.251-0.56-1.251-1.251c0-0.691,0.56-1.251,1.251-1.251 h9.819c0.691,0,1.251,0.56,1.251,1.251C450.016,366.769,449.455,367.33,448.765,367.33z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#495375"
    },
    d: "M456.498,387.345h-25.285c-0.691,0-1.251-0.56-1.251-1.251c0-0.691,0.56-1.251,1.251-1.251 h25.285c0.691,0,1.251,0.56,1.251,1.251C457.749,386.785,457.188,387.345,456.498,387.345z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#495375"
    },
    d: "M452.966,392.349h-18.223c-0.691,0-1.251-0.56-1.251-1.251c0-0.691,0.56-1.251,1.251-1.251 h18.223c0.691,0,1.251,0.56,1.251,1.251C454.217,391.789,453.657,392.349,452.966,392.349z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#495375"
    },
    d: "M448.765,397.353h-9.819c-0.691,0-1.251-0.56-1.251-1.251c0-0.691,0.56-1.251,1.251-1.251 h9.819c0.691,0,1.251,0.56,1.251,1.251C450.016,396.793,449.455,397.353,448.765,397.353z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E36E90"
    },
    d: "M476.857,314.861L476.857,314.861c-14.549-8.842-31.247-13.518-48.271-13.518h-5.708 c-29,0-53.59,23.72-53.57,52.72c0.009,13.142,4.841,25.148,12.807,34.372h39.877h39.876h61.617l-5.416-19.282 C511.702,346.49,496.974,327.087,476.857,314.861z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DF4268"
    },
    d: "M468.702,334.559L468.702,334.559c-10.654-6.475-22.881-9.899-35.348-9.899h-4.18 c-21.236,0-39.243,17.37-39.228,38.606c0.007,9.624,3.545,18.415,9.378,25.17h29.201h29.201h45.12l-3.966-14.12 C494.219,357.72,483.434,343.511,468.702,334.559z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#495375"
    },
    d: "M469.35,380.648h-47.589c-0.747,0-1.353-0.606-1.353-1.353s0.606-1.353,1.353-1.353h47.589 c0.747,0,1.353,0.606,1.353,1.353S470.097,380.648,469.35,380.648z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#495375"
    },
    d: "M467.884,375.291h-47.589c-0.747,0-1.353-0.606-1.353-1.353 c0-0.747,0.606-1.353,1.353-1.353h47.589c0.747,0,1.353,0.606,1.353,1.353 C469.237,374.685,468.631,375.291,467.884,375.291z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#495375"
    },
    d: "M466.418,369.934h-47.589c-0.747,0-1.353-0.606-1.353-1.353 c0-0.747,0.606-1.353,1.353-1.353h47.589c0.747,0,1.353,0.606,1.353,1.353 C467.771,369.328,467.165,369.934,466.418,369.934z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#495375"
    },
    d: "M464.952,364.577h-47.589c-0.747,0-1.353-0.606-1.353-1.353s0.606-1.353,1.353-1.353h47.589 c0.747,0,1.353,0.606,1.353,1.353S465.699,364.577,464.952,364.577z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#495375"
    },
    d: "M463.486,359.219h-47.589c-0.747,0-1.353-0.606-1.353-1.353 c0-0.747,0.606-1.353,1.353-1.353h47.589c0.747,0,1.353,0.606,1.353,1.353 C464.839,358.613,464.233,359.219,463.486,359.219z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A34262"
    },
    d: "M332.626,287.887h127.15l0,0c-2.814,2.814-6.632,4.396-10.612,4.396H344.396 C340.071,292.282,335.892,290.721,332.626,287.887L332.626,287.887z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DF4268"
    },
    d: "M256.35,239.173h-25.936h-11.953v-24.282h8.225c7.06,0,14.034,1.547,20.432,4.533l6.087,2.841 c3.91,1.825,5.957,6.185,4.862,10.359L256.35,239.173z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 214.477,
    y: 214.891,
    style: {
      fill: "#F2C8C2"
    },
    width: 3.984,
    height: 24.282
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.447,
    y: 214.891,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.03,
    height: 24.282
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7D2D7"
    },
    d: "M519.67,284.407c0.529-0.529,0.529-1.385,0-1.913c-0.529-0.529-1.385-0.529-1.914,0 l-11.332,11.332h3.827L519.67,284.407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M506.425,293.826l-18.355,18.356c-0.529,0.529-0.529,1.385,0,1.914 c0.264,0.264,0.611,0.396,0.957,0.396c0.346,0,0.692-0.132,0.957-0.396l20.269-20.269H506.425z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M450.997,298.974h-76.264c-1.246,0-2.255-1.01-2.255-2.255c0-1.246,1.01-2.255,2.255-2.255 h76.264c5.447,0,10.569-2.121,14.421-5.973c4.704-4.704,10.958-7.295,17.61-7.295h74.176c1.246,0,2.255,1.01,2.255,2.255 s-1.01,2.255-2.255,2.255h-74.176c-5.447,0-10.569,2.121-14.421,5.974C463.903,296.383,457.649,298.974,450.997,298.974z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A34262"
    },
    points: "237.405,239.173 256.35,239.173 255.913,241.216 236.828,241.216  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 456.03,
    y: 182.565,
    style: {
      fill: "#F0BF6C"
    },
    width: 133.35,
    height: 98.63
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.212,
    y: 166.474,
    style: {
      fill: "#F0BF6C"
    },
    width: 140.985,
    height: 16.091
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.03,
    y: 182.565,
    style: {
      fill: "#EBA25D"
    },
    width: 133.35,
    height: 7.818
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 470.0621 224.4719)",
    style: {
      fill: "#CC6164",
      fontFamily: "'Montserrat-BlackItalic'",
      fontSize: "20.1199px"
    }
  }, "DELIVERY"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 470.0621 247.1067)",
    style: {
      fill: "#CC6164",
      fontFamily: "'Montserrat-BlackItalic'",
      fontSize: "20.1199px"
    }
  }, "SERVICE")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CC6164"
    },
    points: "472.67,202.197 472.067,204.741 522.704,204.741 540.841,202.197  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CC6164"
    },
    points: "473.579,198.2 472.977,200.745 561.77,200.745 579.907,198.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CC6164"
    },
    points: "472.67,256.775 472.067,259.319 522.704,259.319 540.841,256.775  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CC6164"
    },
    points: "473.579,252.778 472.977,255.322 561.77,255.322 579.907,252.778  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#454F6B"
    },
    d: "M355.331,246.014l-63.743,19.051c-14.101,4.214-20.452,20.587-12.883,33.208l43.668,72.809 l24.808-11.008l-35.651-67.792l72.599-15.174c14.045-2.935,22.317-17.54,17.612-31.095l0,0H355.331z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2C9AD"
    },
    d: "M343.969,365.144l-1.862-2.818l-14.097,6.255l3.318,6.04l15.713-4.409 C346.077,368.489,345.06,366.795,343.969,365.144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M340.093,377.311l-1.313,3.342l1.752-1.233c0.694-0.489,1.523-0.751,2.372-0.751h8.232 c-1.2-2.895-2.564-5.72-4.095-8.458l-15.713,4.409l0.949,1.727h7.159C339.934,376.348,340.275,376.849,340.093,377.311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M322.028,391.705h33.302l-0.607-2.353c-0.94-3.648-2.15-7.214-3.588-10.683h-8.232 c-0.849,0-1.678,0.262-2.372,0.751l-1.752,1.233l1.313-3.342c0.182-0.463-0.159-0.963-0.657-0.963h-7.159l-5.29,4.972 c-2.397,2.252-5.562,3.506-8.851,3.506h-3.605c-3.531,0-6.611,1.968-8.197,4.877l6.867,1.222 C316.115,391.444,319.069,391.705,322.028,391.705z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M322.028,391.705c-2.96,0-5.913-0.261-8.827-0.779l-6.867-1.222 c-0.673,1.235-1.083,2.636-1.135,4.134l10.492,0.95c1.659,0.15,3.324,0.225,4.99,0.225h35.503l-0.853-3.308H322.028z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#422C4F"
    },
    points: "342.107,362.326 328.01,368.581 329.533,371.353 344.883,366.564  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2C9AD"
    },
    d: "M341.188,133.243l-1.93-10.947c-0.646-3.665-3.83-6.337-7.551-6.337h-10.983l0.981,5.198 c0.711,3.764,0.642,7.634-0.203,11.37l-0.48,2.124c-0.203,0.9,0.481,1.755,1.403,1.755h2.221 c2.837,10.261,15.311,14.637,23.974,7.982l13.622-10.463l-7.232,5.052C349.692,142.693,342.314,139.632,341.188,133.243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBA58E"
    },
    d: "M320.016,112.208l0.708,3.751l0,0h10.983c3.721,0,6.905,2.672,7.551,6.337l1.93,10.947 c1.126,6.389,8.504,9.451,13.823,5.735l7.232-5.052l0,0l0.001-0.001v-21.717H320.016z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#422C4F"
    },
    points: "362.243,133.926 348.62,144.389 350.434,149.593 362.243,133.926  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F2C9AD"
    },
    points: "371.778,148.376 362.243,133.926 350.434,149.593 353.524,158.458  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M328.916,124.596c0.206,1.253-0.175,2.358-0.851,2.47c-0.676,0.111-1.391-0.814-1.597-2.067 c-0.206-1.253,0.175-2.358,0.851-2.47C327.994,122.418,328.709,123.343,328.916,124.596z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M325.687,120.187c1.132-0.64,2.399-0.554,3.474,0.158c1.058,0.701,2.044-1.001,0.992-1.698 c-1.649-1.092-3.747-1.126-5.46-0.158C323.592,119.111,324.582,120.811,325.687,120.187L325.687,120.187z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M328.36,132.249l2.201,0.758c3.223,1.111,6.708,1.217,9.993,0.304l5.492-1.548 l-1.289-2.573l-4.203,1.168c-3.285,0.913-6.77,0.807-9.993-0.304l-2.201-0.758c-1.946-0.671-3.942-1.187-5.969-1.545 l-0.789-0.139l-0.718,2.859l1.507,0.234C324.418,131.061,326.414,131.578,328.36,132.249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#81D3CF"
    },
    d: "M346.046,131.763l-5.492,1.548c-3.285,0.913-6.77,0.807-9.993-0.304l-2.201-0.758 c-1.946-0.671-3.942-1.187-5.969-1.545l-1.507-0.234l-0.238,0.945c-0.411,1.636-0.323,3.358,0.252,4.944l1.233,3.4 c2.164,5.964,7.678,10.059,14.013,10.407h0c3.944,0.216,7.827-1.05,10.885-3.55l4.58-3.744L346.046,131.763z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#422C4F"
    },
    d: "M340.673,130.324l0.514,2.918c0.824,4.677,4.999,7.557,9.263,7.314 l-5.694-11.367L340.673,130.324z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#454F6B"
    },
    d: "M348.62,136.332l-4.16,11.855c-0.138,0.392,0.184,0.792,0.596,0.743l0,0 c3.11-0.371,5.862-2.186,7.427-4.899l5.278-9.15L348.62,136.332z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DF4268"
    },
    d: "M344.552,118.209l2.293,12.992c0.391,2.217,2.695,3.538,4.807,2.757l22.588-8.364v-16.167 c0-16.612-13.466-30.078-30.078-30.078l0,0c-16.308,0-29.575,12.98-30.055,29.172h18.896 C338.694,108.52,343.563,112.605,344.552,118.209z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M362.843,103.768c-1.463,0-2.877-0.794-3.601-2.181 c-2.951-5.649-8.729-9.159-15.079-9.159c-2.242,0-4.059-1.817-4.059-4.06c0-2.242,1.817-4.06,4.059-4.06 c9.384,0,17.919,5.18,22.275,13.519c1.039,1.987,0.269,4.44-1.718,5.478 C364.118,103.619,363.476,103.768,362.843,103.768z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M331.741,96.44c-1.251,0-2.485-0.577-3.28-1.664c-1.323-1.81-0.928-4.35,0.881-5.673 l0.189-0.136c1.822-1.307,4.358-0.888,5.664,0.935c1.306,1.822,0.888,4.358-0.935,5.664l-0.127,0.092 C333.411,96.186,332.572,96.44,331.741,96.44z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A34262"
    },
    d: "M351.652,133.958c-2.111,0.782-4.415-0.54-4.807-2.757l-2.293-12.992 c-0.989-5.604-5.858-9.689-11.549-9.689h-18.896c-0.009,0.302-0.023,0.602-0.023,0.906v2.782h17.916 c4.377,0,8.123,3.142,8.884,7.453l2.275,12.89c0.813,4.605,5.723,7.233,10.005,5.355l18.915-8.295 c1.312-0.575,2.159-1.872,2.159-3.305v-0.713L351.652,133.958z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5DABFF"
    },
    d: "M349.801,239.077l5.53-24.186l-7.939-43.502c-0.945-5.18,1.523-10.385,6.132-12.931 l18.255-10.082c2.391-1.32,5.35-1.018,7.424,0.76v0c15.038,12.889,24.446,31.142,26.22,50.868l3.436,38.223 c0.376,4.183-2.918,7.787-7.118,7.787l0,0h-46.409l0,0C351.687,246.014,348.989,242.628,349.801,239.077z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5297F4"
    },
    d: "M377.326,166.458l0.154,0.592c1.919,7.391,0.514,15.251-3.845,21.52l-18.304,26.321 l-3.72-20.385L377.326,166.458z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5DABFF"
    },
    points: "351.812,153.547 346.797,156.141 351.812,161.553 353.524,158.458  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5297F4"
    },
    points: "346.797,156.141 345.659,165.387 350.825,160.488  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6BC5FF"
    },
    points: "374.733,147.56 369.414,142.872 350.434,153.246 353.026,164.222  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2C9AD"
    },
    d: "M267.564,224.573h-14.157c-2.636,0-4.772,2.137-4.772,4.772v8.846 c0,2.636,2.137,4.772,4.772,4.772h11.46v-3.519l0,0c3.454,0,6.766-1.372,9.209-3.814l1.721-1.721L267.564,224.573z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F2C9AD"
    },
    points: "267.564,224.573 275.796,233.908 311.149,225.69 306.258,212.611  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBA58E"
    },
    points: "306.258,212.611 304.532,213.144 303.973,227.358 311.149,225.69  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5DABFF"
    },
    d: "M373.947,162.027L373.947,162.027c-4.662-3.658-11.377-3.005-15.246,1.484l-36.672,42.536 l-6.628,2.234l6.158,16.469l3.477-0.753c5.503-1.192,10.521-4.01,14.402-8.089l35.697-37.51 C379.646,173.66,379.094,166.066,373.947,162.027z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5297F4"
    },
    d: "M321.755,225.275l-0.196-0.524l-6.158-16.469l-0.609-1.629 c-0.349-0.933-1.389-1.407-2.322-1.058l-6.061,2.266c-0.933,0.349-1.407,1.389-1.058,2.322l0.494,1.32l5.76,15.404 l0.71,1.898c0.349,0.933,1.388,1.407,2.322,1.058l6.061-2.266C321.63,227.248,322.104,226.208,321.755,225.275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6BC5FF"
    },
    d: "M361.019,165.283c3.41-3.956,9.105-5.02,13.714-2.567c-0.251-0.237-0.509-0.47-0.786-0.688 l0,0c-4.662-3.658-11.377-3.005-15.246,1.484l-36.672,42.536l-6.628,2.234l0.988,2.643l7.444-2.509L361.019,165.283z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M269.517,239.422c1.076-1.966,3.544-2.687,5.511-1.609l0.015,0.008 c-0.082-0.053-0.153-0.117-0.24-0.165l-9.078-4.974c-1.967-1.078-4.435-0.357-5.511,1.609 c-1.077,1.966-0.357,4.434,1.609,5.511l9.063,4.966C269.113,243.624,268.487,241.301,269.517,239.422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#495375"
    },
    d: "M272.848,245.277c1.435,0,2.826-0.762,3.564-2.109c1.03-1.879,0.403-4.203-1.37-5.346 l-0.015-0.008c-1.967-1.078-4.435-0.357-5.511,1.609c-1.03,1.879-0.403,4.203,1.369,5.346l0.015,0.008 C271.52,245.115,272.189,245.277,272.848,245.277z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBEED1"
    },
    d: "M527.312,439.075c1.857-6.053,2.83-8.628,15.267-9.677c3.404-0.287,6.826,0.847,10.22,0.463 c3.394-0.385,7.008-2.746,7.058-6.162c0.053-3.658-3.945-6.906-2.758-10.366c0.875-2.552,4.091-3.407,6.785-3.25 c2.694,0.157,5.473,0.917,8.029,0.052c3.133-1.061,5.056-4.403,5.365-7.696s-0.7-6.559-1.839-9.665 c-1.139-3.105-2.435-6.212-2.736-9.506c-0.641-7.008,3.388-13.741,8.658-18.403c7.266-6.428,17.139-9.819,26.822-9.211 c9.467,0.594,21.092,4.152,26.508,12.482c3.178,4.889,4.333,11.052,3.139,16.76c-0.504,2.409-1.407,4.891-0.745,7.262 c0.968,3.468,4.769,5.173,8.121,6.49c3.351,1.317,7.123,3.201,7.848,6.727c0.657,3.197-1.655,6.357-4.483,7.986 s-6.131,2.166-9.24,3.16c-3.109,0.994-6.279,2.679-7.658,5.637c-1.179,2.529-0.834,5.536-1.857,8.132 c-1.728,4.386-7.057,6.463-11.738,5.907c-4.681-0.556-8.845-3.143-12.766-5.761c-1.95-1.302-3.918-2.644-6.151-3.359 s-4.814-0.723-6.782,0.551c-2.458,1.591-3.751,4.973-6.617,5.574c-2.78,0.583-5.186-1.792-7.296-3.694 c-2.109-1.902-5.497-3.484-7.574-1.547c-0.91,0.849-1.234,2.134-1.789,3.249c-2.186,4.392-7.877,5.841-12.753,5.295 c-4.876-0.546-9.503-2.554-14.384-3.052C537.086,432.953,528.521,435.133,527.312,439.075z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBEED1"
    },
    d: "M647.074,426.216c4.199-1.374,9.141-0.116,12.171,3.099c1.935,2.053,3.042,5.372,1.42,7.681 c-1.361,1.937-4.11,2.378-6.428,1.902c-2.318-0.477-4.423-1.67-6.68-2.384c-2.257-0.715-4.919-0.877-6.808,0.549 c-0.468,0.353-0.878,0.796-1.411,1.039c-3.318,1.511,0.347-4.791,0.772-5.649C641.539,429.57,643.984,427.228,647.074,426.216 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBEED1"
    },
    d: "M679.69,391.38c2.133-0.499,4.686,0.097,5.82,1.971c1.329,2.195,0.123,5.228-1.973,6.709 c-2.6,1.837-11.703,3.807-13.607-0.165C668.409,396.719,676.972,392.017,679.69,391.38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBEED1"
    },
    d: "M648.769,385.849c0.477,0.88,1.445,1.407,2.429,1.593c0.984,0.186,1.996,0.077,2.991-0.033 c1.757-0.193,3.572-0.405,5.099-1.296c1.526-0.891,2.69-2.657,2.314-4.384C660.17,375.157,645.599,379.996,648.769,385.849z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBEED1"
    },
    d: "M563.173,350.465c-1.573,0.701-2.965,2.197-2.872,3.917c0.069,1.279,0.96,2.411,2.071,3.049 c1.111,0.638,2.416,0.849,3.695,0.921c1.605,0.09,3.356-0.077,4.549-1.155c0.766-0.692,1.197-1.67,1.781-2.521 c1.046-1.526,2.635-2.671,4.414-3.181c1.047-0.3,2.644-0.595,2.679-1.971c0.034-1.376-1.823-2.347-2.976-2.599 c-1.083-0.237-2.053,0.153-3.035,0.577c-1.51,0.652-2.995,1.287-4.603,1.665C566.983,349.612,564.97,349.664,563.173,350.465z "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.0009,
    y1: 94.9815,
    x2: 484.1097,
    y2: 94.9815
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7FCBD0",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5443,
    style: {
      stopColor: "#7FCBD0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9884,
    style: {
      stopColor: "#7FCBD0",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 336.001,
    y: 93.523,
    style: {
      fill: "url(#SVGID_1_)"
    },
    width: 148.109,
    height: 2.917
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101072218477812783560000008147289241338868892_",
    gradientUnits: "userSpaceOnUse",
    x1: 353.5013,
    y1: 100.7914,
    x2: 501.6101,
    y2: 100.7914
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7FCBD0",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5443,
    style: {
      stopColor: "#7FCBD0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9884,
    style: {
      stopColor: "#7FCBD0",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 353.501,
    y: 99.333,
    style: {
      fill: "url(#SVGID_00000101072218477812783560000008147289241338868892_)"
    },
    width: 148.109,
    height: 2.917
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163071949215643218830000006643069505553537941_",
    gradientUnits: "userSpaceOnUse",
    x1: 232.5962,
    y1: 321.7545,
    x2: 380.705,
    y2: 321.7545
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7FCBD0",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5443,
    style: {
      stopColor: "#7FCBD0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9884,
    style: {
      stopColor: "#7FCBD0",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 232.596,
    y: 320.296,
    style: {
      fill: "url(#SVGID_00000163071949215643218830000006643069505553537941_)"
    },
    width: 148.109,
    height: 2.917
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130642128403827760370000001835211515387174808_",
    gradientUnits: "userSpaceOnUse",
    x1: 250.0966,
    y1: 327.5645,
    x2: 398.2054,
    y2: 327.5645
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7FCBD0",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5443,
    style: {
      stopColor: "#7FCBD0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9884,
    style: {
      stopColor: "#7FCBD0",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 250.097,
    y: 326.106,
    style: {
      fill: "url(#SVGID_00000130642128403827760370000001835211515387174808_)"
    },
    width: 148.109,
    height: 2.917
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000050650158518431711250000002274839499128131223_",
    gradientUnits: "userSpaceOnUse",
    x1: 355.4316,
    y1: 164.2221,
    x2: 503.5404,
    y2: 164.2221
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7FCBD0",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5443,
    style: {
      stopColor: "#7FCBD0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9884,
    style: {
      stopColor: "#7FCBD0",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 355.432,
    y: 162.764,
    style: {
      fill: "url(#SVGID_00000050650158518431711250000002274839499128131223_)"
    },
    width: 148.109,
    height: 2.917
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183243925947872086780000015565839484155648655_",
    gradientUnits: "userSpaceOnUse",
    x1: 363.6405,
    y1: 158.4578,
    x2: 566.8922,
    y2: 158.4578
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7FCBD0",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5443,
    style: {
      stopColor: "#7FCBD0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9884,
    style: {
      stopColor: "#7FCBD0",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 363.641,
    y: 156.999,
    style: {
      fill: "url(#SVGID_00000183243925947872086780000015565839484155648655_)"
    },
    width: 203.252,
    height: 2.917
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070091768511973756690000008550307922214552475_",
    gradientUnits: "userSpaceOnUse",
    x1: 340.9439,
    y1: 152.0885,
    x2: 544.1957,
    y2: 152.0885
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7FCBD0",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5443,
    style: {
      stopColor: "#7FCBD0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9884,
    style: {
      stopColor: "#7FCBD0",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 340.944,
    y: 150.63,
    style: {
      fill: "url(#SVGID_00000070091768511973756690000008550307922214552475_)"
    },
    width: 203.252,
    height: 2.917
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181778531301633761610000006420369366422508948_",
    gradientUnits: "userSpaceOnUse",
    x1: 251.6736,
    y1: 233.0984,
    x2: 399.7824,
    y2: 233.0984
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7FCBD0",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5443,
    style: {
      stopColor: "#7FCBD0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9884,
    style: {
      stopColor: "#7FCBD0",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 251.674,
    y: 231.64,
    style: {
      fill: "url(#SVGID_00000181778531301633761610000006420369366422508948_)"
    },
    width: 148.109,
    height: 2.917
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000213090393853207690000002101396033232558746_",
    gradientUnits: "userSpaceOnUse",
    x1: 259.8824,
    y1: 227.3342,
    x2: 463.1342,
    y2: 227.3342
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7FCBD0",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5443,
    style: {
      stopColor: "#7FCBD0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9884,
    style: {
      stopColor: "#7FCBD0",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 259.882,
    y: 225.876,
    style: {
      fill: "url(#SVGID_00000000213090393853207690000002101396033232558746_)"
    },
    width: 203.252,
    height: 2.917
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058588504347210451500000017243531283294268860_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.1859,
    y1: 220.9649,
    x2: 440.4376,
    y2: 220.9649
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7FCBD0",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5443,
    style: {
      stopColor: "#7FCBD0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9884,
    style: {
      stopColor: "#7FCBD0",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 237.186,
    y: 219.506,
    style: {
      fill: "url(#SVGID_00000058588504347210451500000017243531283294268860_)"
    },
    width: 203.252,
    height: 2.917
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086658133235540429620000011258262315119142047_",
    gradientUnits: "userSpaceOnUse",
    x1: 485.4048,
    y1: 320.558,
    x2: 633.5136,
    y2: 320.558
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7FCBD0",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5443,
    style: {
      stopColor: "#7FCBD0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9884,
    style: {
      stopColor: "#7FCBD0",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 485.405,
    y: 319.099,
    style: {
      fill: "url(#SVGID_00000086658133235540429620000011258262315119142047_)"
    },
    width: 148.109,
    height: 2.917
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031193329599336976570000000383236203514412419_",
    gradientUnits: "userSpaceOnUse",
    x1: 450.5638,
    y1: 314.7938,
    x2: 653.8155,
    y2: 314.7938
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7FCBD0",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5443,
    style: {
      stopColor: "#7FCBD0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9884,
    style: {
      stopColor: "#7FCBD0",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 450.564,
    y: 313.335,
    style: {
      fill: "url(#SVGID_00000031193329599336976570000000383236203514412419_)"
    },
    width: 203.252,
    height: 2.917
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072258720478146847240000015679915190814320528_",
    gradientUnits: "userSpaceOnUse",
    x1: 427.8672,
    y1: 308.4245,
    x2: 631.119,
    y2: 308.4245
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7FCBD0",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5443,
    style: {
      stopColor: "#7FCBD0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9884,
    style: {
      stopColor: "#7FCBD0",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 427.867,
    y: 306.966,
    style: {
      fill: "url(#SVGID_00000072258720478146847240000015679915190814320528_)"
    },
    width: 203.252,
    height: 2.917
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderConfirmed2);
export default __webpack_public_path__ + "static/media/order_confirmed2.f189b2fb2e067b8bcda2338bd2812342.svg";
export { ForwardRef as ReactComponent };